import axios from "axios";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import Select from "react-select";
import swal from "sweetalert";
import useSWR from "swr";
import Api from "../../../../../initialpage/hooks/Api";
import useAuth from "../../../../../initialpage/hooks/useAuth";
import { API } from "../../../StoreComponents/conflict";
import { PostStoreLog } from "../../../StoreComponents/hooks/useStoreLog";
import "./ExistingEntry.css";
import Cookies from "js-cookie";
const fetcher = (url) => API.get(url).then((res) => res.data.data);

const fetcher1 = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);
const ExistingEntry = () => {
  const [fixedData, setFixedData] = useState({});
  const [showupdateBtn, setShowupdateBtn] = useState([]);
  const [oldProduct, setOldProduct] = useState({});
  const [productArray, setProductArray] = useState([]);
  const [localStorageProducts, setLocalStorageProducts] = useState([]);
  const [productOption, setProductOption] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [supplierDate, setSupplierDate] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [loading, setLoading] = useState(false);
  const [updatedQty, setUpdateQty] = useState(null);
  const user = JSON.parse(Cookies.get("user") || '{}');
  // console.log(user?.name_english);
  // get MRR Data
  const {
    data: MRRData,
    error,
    mutate,
  } = useSWR(`store/products/lastMrrNumber`, fetcher);
  // get supplierData
  const { data: supplierOption, error: error1 } = useSWR(
    `store/settings/suppliers?page=${0}&limit=${10000}`,
    fetcher1
  );
  // get categoryData
  const { data: categoryOption, error: error2 } = useSWR(
    `store/settings/categories?page=${0}&limit=${10000}`,
    fetcher1
  );

  // set supplier category select list
  let supplierCategory = [];
  if (supplierOption && supplierOption.length > 0) {
    supplierCategory = supplierOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.sup_id;
      optionsItem.label = `${data.supplier}`;
      return optionsItem;
    });
  }

  // set category select list
  let category = [];
  if (categoryOption && categoryOption.length > 0) {
    category = categoryOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.cat_id;
      optionsItem.label = `${data.categoryen} (${data.categorybn})`;
      return optionsItem;
    });
  }

  // set Product select list
  let productCategory = [];
  if (productOption && productOption.length > 0) {
    productCategory = productOption.map((data) => {
      let optionsItem = {};

      optionsItem.value = data.PROID;
      optionsItem.label = `${data.PRONAME} - ${data.PRONAMETWO}`;
      return optionsItem;
    });
  }

  // handle supplier select;
  const handleSupplier = (name) => {
    setSelectedSupplier(name);
  };

  // handle product select;
  const handleProduct = (product) => {
    setSelectedProduct(product);
    API.get(
      product.value
        ? `store/products/getStoreProductByListId/${product.value}`
        : null
    ).then((res) => setOldProduct(res.data.data));
  };

  //console.log(oldProduct);
  // handle Category select;
  const handleCategory = (name) => {
    const id = name.value;
    setSelectedCategory(name.value);
    API.get(
      id ? `store/products/getStoreProductByCategoryId/${id}` : null
    ).then((res) => setProductOption(res.data.data));
  };
  //console.log(productOption);
  // react hook form
  const { register, handleSubmit, reset } = useForm();

  // handle change Quantity Amount
  const changeQuantityAmount = (id, e) => {
    setShowupdateBtn([...showupdateBtn, "true", id]);
    const quantity = parseInt(e.target.value);
    setUpdateQty(quantity);
  };

  // update temporary state
  const updateProduct = (id) => {
    const fil = localStorageProducts.map((item) => {
      let myItem = item;
      if (item.proid === parseInt(id)) {
        myItem.qty = updatedQty;
      }
      return myItem;
    });
    // console.log(fil)

    localStorage.setItem("ExistingDataItems", JSON.stringify(fil));
    setShowupdateBtn([]);
    swal({
      title: "Thank You !",
      text: "Successfully Updated",
      icon: "success",
      button: "Ok",
    });
  };

  let count = 1;
  const onSubmit = (data) => {
    // reset();

    const initial = {
      mrrnno: MRRData,
      supplier: selectedSupplier ? selectedSupplier : fixedData.supplier,
      suppdate: supplierDate ? supplierDate : fixedData.suppdate,
      workorder: data.WORK_ORDER_NUMBER
        ? data.WORK_ORDER_NUMBER
        : fixedData.workorder,
      workodate: data.WORK_ORDER_DATE
        ? data.WORK_ORDER_DATE
        : fixedData.workodate,
      cashmemono: data.BILL_NO ? data.BILL_NO : fixedData.cashmemono,
      cashmemodate: supplierDate ? supplierDate : fixedData.cashmemodate,
      username: user?.name_english,
    };

    //console.log(data);
    // setFixedData(initial);
    localStorage.setItem("ExistingDataFixed", JSON.stringify(initial));

    if (data.NEW_QUANTITY) {
      data.NEW_QUANTITY = parseFloat(data.NEW_QUANTITY);
    } else {
      data.NEW_QUANTITY = oldProduct.PROQTY;
    }
    if (data.NEW_AMOUNT) {
      data.NEW_AMOUNT = parseFloat(data.NEW_AMOUNT);
    } else {
      data.NEW_AMOUNT = oldProduct.STOCKPRICE;
    }

    //   "proid": oldProduct.PROID,
    //   "proname": oldProduct.PRONAME,
    //   "pro_name_two":oldProduct.PRONAMETWO,
    //   "qty": data.NEW_QUANTITY,
    //   "price": data.NEW_AMOUNT,
    //   "category": oldProduct.PROCATE,
    //   "prod_unit":

    const { value } = selectedProduct;
    const found = localStorageProducts.find((item) => item.proid === value);
    if (found) {
      window.alert("Product already in cart");
    } else {
      const newProduct = {
        proid: oldProduct.PROID,
        prod_unit: oldProduct.PRODUNIT,
        proname: oldProduct.PRONAME,
        pro_name_two: oldProduct.PRONAMETWO,
        qty: data.NEW_QUANTITY,
        price: data.NEW_AMOUNT,
        category: oldProduct.PROCATE,
      };
      //console.log(newProduct);
      setLocalStorageProducts([...localStorageProducts, newProduct]);
      const newArray = [...localStorageProducts, newProduct];
      localStorage.setItem("ExistingDataItems", JSON.stringify(newArray));
      reset();
      setOldProduct({});
      setLoading(true);
      setSelectedSupplier("");
      setSelectedProduct("");
    }
  };

  const deleteProduct = (id) => {
    const proceed = window.confirm("Are you sure?");
    if (proceed) {
      const remaining = localStorageProducts.filter(
        (product) => product.proid !== id
      );
      setLocalStorageProducts(remaining);
      localStorage.setItem("ExistingDataItems", JSON.stringify(remaining));
    }
  };
  const [buttonLoading, setButtonLoading] = useState(false);
  //   Handle Submit
  const handleRequest = () => {
    //console.log(localStorageProducts);
    if (localStorageProducts.length > 0) {
      setButtonLoading(true);
      let localFixed = localStorage.getItem("ExistingDataFixed")
        ? JSON.parse(localStorage.getItem("ExistingDataFixed"))
        : {};
      localFixed["products"] = localStorageProducts;
      localFixed.supplier = localFixed.supplier.value;

      API.put("store/products/productEntriesList", localFixed).then((res) => {
        console.log(res);
        if (!res.data.error) {
          swal({
            title: "Thank You !",
            text: "Successfully Added",
            icon: "success",
            button: "Ok",
          });
          setLoading(true);
          PostStoreLog(2, "Store Existing Product entry");

          setButtonLoading(false);
          mutate();
          localStorage.setItem("ExistingDataItems", JSON.stringify([]));
          localStorage.setItem("ExistingDataFixed", JSON.stringify({}));
        }
      });
    } else {
      swal({
        title: "OPPS !",
        text: "No products found",
        icon: "error",
        button: "Ok",
      });
      setButtonLoading(false);
    }
  };

  useEffect(() => {
    const localProducts = localStorage.getItem("ExistingDataItems")
      ? JSON.parse(localStorage.getItem("ExistingDataItems"))
      : [];
    setLocalStorageProducts(localProducts);

    const localFixedData = localStorage.getItem("ExistingDataFixed")
      ? JSON.parse(localStorage.getItem("ExistingDataFixed"))
      : {};
    setFixedData(localFixedData);
    setLoading(false);
  }, [loading]);

  const handleResetData = () => {
    const confirmReset = window.confirm(
      "Are you sure you want to reset all data? This action cannot be undone."
    );
    if (confirmReset) {
      localStorage.setItem("ExistingDataItems", JSON.stringify([]));
      localStorage.setItem("ExistingDataFixed", JSON.stringify({}));
      alert("Data has been reset.");
      window.location.reload();
    }
  };
  return (
    <>
      <Helmet>
        <title>Existing Product Entry - BBA STORE</title>
        <meta name="description" content="Product List - BBA STORE" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>
      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">
              Update Existing Products To Office Store
            </h3>
            <button
              className="bg-black text-white"
              onClick={() => handleResetData()}
            >
              Reset Data
            </button>
          </div>

          <div
            style={{ background: "white", borderRadius: "10px" }}
            className="p-3"
          >
            <div className="add_category py-5">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-3 mt-1">
                    <label htmlFor="Supplier">
                      MRR Number <span className="color-red">*</span>
                    </label>
                    <input
                      defaultValue={MRRData}
                      type="text"
                      className="input-field-existing p-2"
                      readOnly
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-3">
                    <label htmlFor="Supplier">
                      Supplier <span className="color-red">*</span>
                    </label>
                    <Select
                      isDisabled={fixedData.supplier ? true : false}
                      placeholder={
                        fixedData.supplier
                          ? fixedData.supplier.label
                          : "Select.."
                      }
                      onChange={handleSupplier}
                      style={{ borderRadius: "10px" }}
                      className="text-start fs-6"
                      options={supplierCategory}
                    />
                    <input
                      tabIndex={-1}
                      autoComplete="off"
                      style={{ opacity: 0, height: 0 }}
                      value={selectedSupplier}
                      required={fixedData.supplier ? false : true}
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-3">
                    <label htmlFor="To_Date">
                      Supplier Date <span className="color-red">*</span>
                    </label>
                    <input
                      readOnly={fixedData.suppdate ? true : false}
                      defaultValue={
                        fixedData.suppdate ? fixedData.suppdate : ""
                      }
                      onChange={(e) => setSupplierDate(e.target.value)}
                      type="date"
                      className="p-2 input-field-existing"
                      required
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-3">
                    <label htmlFor="Supplier">
                      Work Order Number <span className="color-red">*</span>
                    </label>
                    <input
                      readOnly={fixedData.workorder ? true : false}
                      defaultValue={
                        fixedData.workorder ? fixedData.workorder : ""
                      }
                      {...register("WORK_ORDER_NUMBER")}
                      type="text"
                      className="input-field-existing  p-2"
                      required
                    />
                  </div>
                </div>

                <div className="row mt-5">
                  <div className="col-12 col-md-6 col-lg-3">
                    <label htmlFor="work_order">
                      Work Order Date <span className="color-red">*</span>
                    </label>
                    <input
                      readOnly={fixedData.workodate ? true : false}
                      defaultValue={
                        fixedData.workodate ? fixedData.workodate : ""
                      }
                      {...register("WORK_ORDER_DATE")}
                      type="date"
                      className="p-2 input-field-existing"
                      required
                    />
                  </div>
                  <div className="col-12 col-md-4 col-lg-3">
                    <label htmlFor="Cash_memo">
                      Cash Memo/Bill No. <span className="color-red">*</span>
                    </label>
                    <input
                      readOnly={fixedData.cashmemono ? true : false}
                      defaultValue={
                        fixedData.cashmemono ? fixedData.cashmemono : ""
                      }
                      {...register("BILL_NO")}
                      type="text"
                      className="input-field-existing  p-2"
                      required
                    />
                  </div>

                  <div className="col-12 col-md-4 col-lg-3">
                    <label htmlFor="cash_memo_date">
                      Cash Memo/Bill Date <span className="color-red">*</span>
                    </label>
                    <input
                      defaultValue={
                        fixedData.cashmemodate
                          ? fixedData.cashmemodate
                          : supplierDate
                      }
                      className="p-2 input-field-existing"
                      type="date"
                      readOnly
                    />
                  </div>
                </div>

                <div className="row mt-5">
                  <div className="col-12 col-md-6 col-lg-6">
                    <label htmlFor="product_category">
                      Category <span className="color-red">*</span>
                    </label>
                    <Select
                      onChange={handleCategory}
                      style={{ borderRadius: "10px" }}
                      className="text-start input-field-existing fs-6"
                      options={category}
                    />
                    <input
                      tabIndex={-1}
                      autoComplete="off"
                      style={{ opacity: 0, height: 0 }}
                      value={selectedCategory}
                      required
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-6">
                    <label htmlFor="product_name" className="">
                      Product Name <span className="color-red">*</span>
                    </label>
                    <Select
                      onChange={handleProduct}
                      style={{ borderRadius: "10px" }}
                      className="text-start fs-6"
                      options={productCategory}
                    />
                    <input
                      tabIndex={-1}
                      autoComplete="off"
                      style={{ opacity: 0, height: 0 }}
                      value={selectedProduct}
                      required
                    />
                  </div>
                </div>

                <div className="row mt-5">
                  <p className="text-start fw-light text-black">
                    Old Product Status
                  </p>
                  <div className="col-12 col-md-6 col-lg-12">
                    <div id="printArea" className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr className="tableColor">
                            <th>Qty</th>
                            <th>Price</th>
                            <th>Unit</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            <tr>
                              <td className="text-center">
                                {oldProduct ? oldProduct.PROQTY : ""}
                              </td>
                              <td className="text-center">
                                {oldProduct ? oldProduct.STOCKPRICE : ""}
                              </td>
                              <td>{oldProduct ? oldProduct.UNIT : ""}</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 col-lg-6">
                    <div className="row">
                      <div className="col-12 col-md-6 col-lg-6">
                        <label htmlFor="new_quantity">
                          New Product Quantity{" "}
                          <span className="color-red">*</span>
                        </label>
                        <input
                          {...register("NEW_QUANTITY")}
                          type="number"
                          min="1"
                          required
                          className="input-field-existing  p-2"
                        />
                      </div>

                      <div className="col-12 col-md-6 col-lg-6">
                        <label htmlFor="new_amount">
                          New Product Amount{" "}
                          <span className="color-red">*</span>
                        </label>
                        <input
                          {...register("NEW_AMOUNT")}
                          type="number"
                          min="1"
                          required
                          className="input-field-existing  p-2"
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <button
                      type="submit"
                      className="btn btn-color_store px-3 mt-5"
                    >
                      <i className="fa fa-plus" />
                      <span> Add</span>
                    </button>
                  </div>
                </div>
              </form>

              <div className="row mt-5">
                <p className="text-start text-black fw-light">
                  New Product Status
                </p>
                <div className="col-12">
                  <div id="printArea" className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr className="tableColor">
                          <th>S/N</th>
                          {/* <th>Supplier</th> */}
                          <th>Name</th>
                          <th>Qty</th>
                          <th>Price</th>
                          <th>Total</th>
                          {/* <th>Unit</th> */}
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {localStorageProducts.length > 0 &&
                          localStorageProducts.map((product, index) => {
                            const {
                              proid,
                              proname,
                              pro_name_two,
                              qty,
                              price,
                              category,
                            } = product;
                            //console.log(product)
                            return (
                              <tr key={index}>
                                <td className="text-center">{index + 1}</td>
                                {/* <td>{supplier}</td> */}
                                <td>{proname}</td>
                                <td className="text-center">
                                  {" "}
                                  <input
                                    type="number"
                                    min="1"
                                    onChange={(e) =>
                                      changeQuantityAmount(proid, e)
                                    }
                                    defaultValue={qty}
                                    style={{
                                      width: "60px",
                                      paddingLeft: "5px",
                                    }}
                                    className="input-field-new"
                                  />{" "}
                                </td>
                                <td>{price}</td>
                                <td>{qty * price}</td>
                                {/* <td>{prod_unit}</td> */}

                                <td>
                                  <button
                                    onClick={() => deleteProduct(proid)}
                                    data-bs-toggle="tooltip"
                                    title="Delete"
                                    type="button"
                                    className="btn btn-red px-3"
                                  >
                                    <i className="fa fa-times fs-6"></i>
                                  </button>
                                  {showupdateBtn[0] === "true" &&
                                    showupdateBtn[1] === proid ? (
                                    <button
                                      onClick={() => updateProduct(proid)}
                                      data-bs-toggle="tooltip"
                                      title="update"
                                      type="button"
                                      className="btn btn-outline-color_store bg-primary text-white px-3 ms-3"
                                    >
                                      <i className="fa fa-check fs-6"></i>
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                    {!buttonLoading ? (
                      <button
                        onClick={handleRequest}
                        type="button"
                        className="px-4 mt-3 btn btn-color_store"
                      >
                        <i className="fa fa-file fs-6"></i>
                        <span> Save</span>{" "}
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="px-4 mt-3 btn btn-color_store"
                      >
                        <i className="fa fa-file fs-6"></i>
                        <span> Save</span>{" "}
                        <div
                          style={{ width: "20px", height: "20px" }}
                          class="spinner-border ms-2  text-light"
                          role="status"
                        >
                          <span class="visually-hidden ">Loading...</span>
                        </div>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExistingEntry;
